module.exports = __webpack_public_path__ + "img/lagoon-systems.b8be780c.svg";